<!-- Button -->
<button
    mat-icon-button
    [matTooltip]="tooltip || (isFullscreen ? 'Exit Fullscreen' : 'Toggle Fullscreen')"
    (click)="toggleFullscreen()"
>
    <ng-container [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon [svgIcon]="isFullscreen ? 'heroicons_outline:arrows-pointing-in' : 'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
</ng-template>
